import React from "react";
import { resource as res, ResourceTypes } from "@planzone/dto";
import { useRetrieveGantt } from "@planzone/view-models";
import { Props } from "./types";
import { Flag } from "@common/infiniteScroll";
import { useToggle } from "@common/treeToggle";

function ResourceCtx({ resource, sort, zone, children }: Props) {
  const { isOpen } = useToggle(resource.uuid, 0, false);
  const {
    gantt,
    isRequestPending,
    canRetrieveNextElements,
    currentPage,
    retrieveGantt,
  } = useRetrieveGantt(25, sort, zone, [{ ...res, uuid: resource.uuid }]);
  const hasInitializedRef = React.useRef(false);

  React.useEffect(() => {
    if (isOpen && !hasInitializedRef.current) {
      hasInitializedRef.current = true;

      if (!isRequestPending) {
        retrieveGantt({
          size: 25,
          page: currentPage,
          zone,
          sort,
          resources: [
            {
              ...res,
              uuid: resource.uuid,
              name: resource.resourceName,
              type: resource.resourceType as ResourceTypes,
            },
          ],
        });
      }
    }
  }, [isOpen, retrieveGantt, resource.uuid, zone]);

  React.useEffect(() => {
    hasInitializedRef.current = false;
  }, [resource.uuid]);

  return (
    <>
      {isOpen
        ? children(gantt.projects, isRequestPending)
        : children([], false)}
    </>
  );
}

export { ResourceCtx };
